<template>
    <article class="person-prerender-snapshot" data-prerender-kind="person">
        <header>
            <p class="person-prerender-snapshot__eyebrow">{{ $t('personPage.prerender.eyebrow') }}</p>
            <h1>{{ displayName }}</h1>
            <p v-if="person.nickname" class="person-prerender-snapshot__nickname">
                {{ $t('personPage.prerender.nickname', { nickname: person.nickname }) }}
            </p>
            <p class="person-prerender-snapshot__lifespan">{{ lifespan }}</p>
        </header>

        <div class="person-prerender-snapshot__biography">
            <p v-for="sentence in biography" :key="sentence">{{ sentence }}</p>
        </div>

        <section v-if="person.spouses?.length">
            <h2>{{ $t('personPage.prerender.family') }}</h2>
            <p>
                <template v-for="(spouse, index) in person.spouses" :key="spouse.personID">
                    <span v-if="index > 0">, </span>
                    <a :href="localePath(`/person/${spouse.personID}`)">{{ spouse.name }}</a>
                </template>
            </p>
        </section>
    </article>
</template>

<script>
import { buildPersonBiography, personDisplayName, personLifespan } from '@/utils/personSeoContent';

export default {
    name: 'PersonPrerenderSnapshot',
    props: {
        person: {
            type: Object,
            required: true,
        },
        locale: {
            type: String,
            default: 'nl',
        },
        localePath: {
            type: Function,
            required: true,
        },
    },
    computed: {
        displayName() {
            return personDisplayName(this.person);
        },
        lifespan() {
            return personLifespan(this.person, this.locale);
        },
        biography() {
            return buildPersonBiography(this.person, this.locale, this.$t);
        },
    },
};
</script>

<style scoped>
.person-prerender-snapshot {
    max-width: 760px;
    margin: 0 auto;
    padding: 72px 24px;
    color: #242424;
    font-family: Arial, sans-serif;
    line-height: 1.6;
}

.person-prerender-snapshot header {
    margin-bottom: 40px;
}

.person-prerender-snapshot__eyebrow {
    margin: 0 0 8px;
    color: #8c1d24;
    font-weight: 700;
}

.person-prerender-snapshot h1 {
    margin: 0;
    font-size: 2.25rem;
}

.person-prerender-snapshot__nickname,
.person-prerender-snapshot__lifespan {
    margin: 8px 0 0;
    font-size: 1.125rem;
}

.person-prerender-snapshot__biography p {
    margin: 0 0 12px;
}

.person-prerender-snapshot section {
    margin-top: 36px;
}

.person-prerender-snapshot a {
    color: #8c1d24;
}
</style>
